var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    clipPath: "url(#clip0_468_141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow-left-1",
    d: "M5.75001 8.80452C5.75216 8.53997 5.65388 8.28445 5.47501 8.08952L2.55176 4.99989L5.47501 1.91027C5.84639 1.50726 5.84639 0.886716 5.47501 0.483707C5.30182 0.294732 5.05725 0.187134 4.80092 0.187134C4.54458 0.187134 4.30002 0.294732 4.12682 0.483707L0.529824 4.28696C0.156725 4.6885 0.156725 5.30991 0.529824 5.71146L4.12339 9.51608C4.29658 9.70506 4.54114 9.81265 4.79748 9.81265C5.05382 9.81265 5.29838 9.70506 5.47157 9.51608C5.65022 9.32239 5.74853 9.06801 5.74657 8.80452",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.5,
    height: 10,
    fill: "currentColor",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.e64347268c6498f1b4d8310525f4ca06.svg";
export { ForwardRef as ReactComponent };